import { TeamsInterface } from '@/types/generated/graphql';
import { AppAvatar } from '@components/app-avatar';

export function TeamCard(team: TeamsInterface) {
  return (
    <div className="flex items-center gap-2">
      <AppAvatar className="shrink-0 size-7! lg:size-9! border-gray-500!" name={team?.name as string} />
      <p className="truncate leading-5 text-[15px] lg:text-base text-text-700 group-[.ant-menu-item-selected]:text-text-800">
        {team?.name}
      </p>
    </div>
  );
}
